import { trpc } from '@/shared/api';

interface InvalidateFonts {
  /** 마스터 목록만 — 폰트 추가. 새 폰트는 어느 상품에도 허용되지 않은 채 시작한다. */
  readonly list: () => void;
  /** 한 상품의 허용 목록 — 상품 편집 화면의 허용 폰트 저장. */
  readonly forProduct: (productId: string) => void;
  /**
   * 마스터 목록·모든 상품의 허용 목록·id 이름 찾기 — 이름 변경·삭제. 삭제는 모든 상품에서 연결을 지우므로,
   * 상품 화면에 지운 폰트가 남은 채 저장하면 400 이다(staleTime 동안 옛 목록이 보이지 않게).
   * 견적 상세의 폰트 이름·'(삭제됨)' 표시도 바로 바뀐다.
   */
  readonly afterMasterChange: () => void;
}

/** 폰트 캐시 무효화 묶음 — 바뀐 범위만큼만 다시 불러온다. */
export const useInvalidateFonts = (): InvalidateFonts => {
  const utils = trpc.useUtils();
  const fonts = utils.productManagement.fonts;

  return {
    list: () => void fonts.list.invalidate(),
    forProduct: (productId) => void fonts.listForProduct.invalidate({ productId }),
    afterMasterChange: () => {
      void fonts.list.invalidate();
      void fonts.listForProduct.invalidate();
      void fonts.listByIds.invalidate();
    },
  };
};
